// Fetch runes
export const FETCH_RUNES_REQUEST = 'RUNAS/FETCH_RUNES_REQUEST';
export const fetchRunesRequest = () => ({ type: FETCH_RUNES_REQUEST });

export const FETCH_RUNES_SUCCESS = 'RUNAS/FETCH_RUNES_SUCCESS';
export const fetchRunesSuccess = (runes) =>
  ({ type: FETCH_RUNES_SUCCESS, payload: { runes } });

export const FETCH_RUNES_FAILURE = 'RUNAS/FETCH_RUNES_FAILURE';
export const fetchRunesFailure = (error) =>
  ({ type: FETCH_RUNES_FAILURE, payload: { error } });

// Simple reading (1 rune + question, predefined)
export const GET_INDEX_READING_REQUEST = 'RUNAS/GET_INDEX_READING_REQUEST';
export const getIndexReadingRequest = (question, rune_id) =>
  ({ type: GET_INDEX_READING_REQUEST, payload: { question, rune_id } });

export const GET_INDEX_READING_SUCCESS = 'RUNAS/GET_INDEX_READING_SUCCESS';
export const getIndexReadingSuccess = (reading) =>
  ({ type: GET_INDEX_READING_SUCCESS, payload: { reading } });

export const GET_INDEX_READING_FAILURE = 'RUNAS/GET_INDEX_READING_FAILURE';
export const getIndexReadingFailure = (error) =>
  ({ type: GET_INDEX_READING_FAILURE, payload: { error } });

export const RESET_INDEX_READING = 'RUNAS/RESET_INDEX_READING';
export const resetIndexReading = () => ({ type: RESET_INDEX_READING });

export const SET_INDEX_READING_LIKE_REQUEST = 'RUNAS/SET_INDEX_READING_LIKE_REQUEST';
export const setIndexReadingLikeRequest = (reading_id, like) =>
  ({ type: SET_INDEX_READING_LIKE_REQUEST, payload: { reading_id, like } });

export const SET_INDEX_READING_LIKE_SUCCESS = 'RUNAS/SET_INDEX_READING_LIKE_SUCCESS';
export const setIndexReadingLikeSuccess = () =>
  ({ type: SET_INDEX_READING_LIKE_SUCCESS });

// Email trial (3 runes, public)
export const REQUEST_THREE_RUNE_EMAIL_REQUEST = 'RUNAS/REQUEST_THREE_RUNE_EMAIL_REQUEST';
export const requestThreeRuneEmailRequest = (payload) =>
  ({ type: REQUEST_THREE_RUNE_EMAIL_REQUEST, payload });

export const REQUEST_THREE_RUNE_EMAIL_SUCCESS = 'RUNAS/REQUEST_THREE_RUNE_EMAIL_SUCCESS';
export const requestThreeRuneEmailSuccess = () =>
  ({ type: REQUEST_THREE_RUNE_EMAIL_SUCCESS });

export const REQUEST_THREE_RUNE_EMAIL_FAILURE = 'RUNAS/REQUEST_THREE_RUNE_EMAIL_FAILURE';
export const requestThreeRuneEmailFailure = (error) =>
  ({ type: REQUEST_THREE_RUNE_EMAIL_FAILURE, payload: { error } });

// Authenticated deep (3 runes)
export const CREATE_THREE_RUNE_REQUEST = 'RUNAS/CREATE_THREE_RUNE_REQUEST';
export const createThreeRuneRequest = (payload) =>
  ({ type: CREATE_THREE_RUNE_REQUEST, payload });

export const CREATE_THREE_RUNE_SUCCESS = 'RUNAS/CREATE_THREE_RUNE_SUCCESS';
export const createThreeRuneSuccess = (reading) =>
  ({ type: CREATE_THREE_RUNE_SUCCESS, payload: { reading } });

export const CREATE_THREE_RUNE_FAILURE = 'RUNAS/CREATE_THREE_RUNE_FAILURE';
export const createThreeRuneFailure = (error) =>
  ({ type: CREATE_THREE_RUNE_FAILURE, payload: { error } });

export const RESET_THREE_RUNE = 'RUNAS/RESET_THREE_RUNE';
export const resetThreeRune = () => ({ type: RESET_THREE_RUNE });

// Anonymous per-reading purchase (pay-to-generate)
export const CREATE_PENDING_THREE_RUNE_REQUEST = 'RUNAS/CREATE_PENDING_THREE_RUNE_REQUEST';
export const createPendingThreeRuneRequest = (email, question, runesIds) =>
  ({ type: CREATE_PENDING_THREE_RUNE_REQUEST, payload: { email, question, runes_ids: runesIds } });
export const CREATE_PENDING_THREE_RUNE_SUCCESS = 'RUNAS/CREATE_PENDING_THREE_RUNE_SUCCESS';
export const createPendingThreeRuneSuccess = (readingId) =>
  ({ type: CREATE_PENDING_THREE_RUNE_SUCCESS, payload: { readingId } });
export const CREATE_PENDING_THREE_RUNE_FAILURE = 'RUNAS/CREATE_PENDING_THREE_RUNE_FAILURE';
export const createPendingThreeRuneFailure = (error) =>
  ({ type: CREATE_PENDING_THREE_RUNE_FAILURE, payload: error });

export const RUNAS_CHECKOUT_REQUEST = 'RUNAS/CHECKOUT_REQUEST';
export const runasCheckoutRequest = (email, readingId) =>
  ({ type: RUNAS_CHECKOUT_REQUEST, payload: { email, reading_id: readingId } });
export const RUNAS_CHECKOUT_SUCCESS = 'RUNAS/CHECKOUT_SUCCESS';
export const runasCheckoutSuccess = () => ({ type: RUNAS_CHECKOUT_SUCCESS });
export const RUNAS_CHECKOUT_FAILURE = 'RUNAS/CHECKOUT_FAILURE';
export const runasCheckoutFailure = (e) => ({ type: RUNAS_CHECKOUT_FAILURE, payload: e });

export const RUNAS_PAYPAL_REQUEST = 'RUNAS/PAYPAL_REQUEST';
export const runasPaypalOrderRequest = (email, readingId) =>
  ({ type: RUNAS_PAYPAL_REQUEST, payload: { email, reading_id: readingId } });
export const RUNAS_PAYPAL_SUCCESS = 'RUNAS/PAYPAL_SUCCESS';
export const runasPaypalOrderSuccess = () => ({ type: RUNAS_PAYPAL_SUCCESS });
export const RUNAS_PAYPAL_FAILURE = 'RUNAS/PAYPAL_FAILURE';
export const runasPaypalOrderFailure = (e) => ({ type: RUNAS_PAYPAL_FAILURE, payload: e });

export const RUNAS_VERIFY_REQUEST = 'RUNAS/VERIFY_REQUEST';
export const runasVerifyPurchaseRequest = (sessionId) =>
  ({ type: RUNAS_VERIFY_REQUEST, payload: { session_id: sessionId } });
export const RUNAS_VERIFY_SUCCESS = 'RUNAS/VERIFY_SUCCESS';
export const runasVerifyPurchaseSuccess = (data) =>
  ({ type: RUNAS_VERIFY_SUCCESS, payload: data });
export const RUNAS_VERIFY_FAILURE = 'RUNAS/VERIFY_FAILURE';
export const runasVerifyPurchaseFailure = (e) => ({ type: RUNAS_VERIFY_FAILURE, payload: e });

export const RUNAS_VERIFY_PAYPAL_REQUEST = 'RUNAS/VERIFY_PAYPAL_REQUEST';
export const runasVerifyPaypalRequest = (paypalOrderId) =>
  ({ type: RUNAS_VERIFY_PAYPAL_REQUEST, payload: { paypal_order_id: paypalOrderId } });
export const RUNAS_VERIFY_PAYPAL_SUCCESS = 'RUNAS/VERIFY_PAYPAL_SUCCESS';
export const runasVerifyPaypalSuccess = (data) =>
  ({ type: RUNAS_VERIFY_PAYPAL_SUCCESS, payload: data });
export const RUNAS_VERIFY_PAYPAL_FAILURE = 'RUNAS/VERIFY_PAYPAL_FAILURE';
export const runasVerifyPaypalFailure = (e) => ({ type: RUNAS_VERIFY_PAYPAL_FAILURE, payload: e });
